// removed by extract-text-webpack-plugin
module.exports = {"chapterWrapper":"src-templates----Chapter-module---chapterWrapper---3dN4N","exiting":"src-templates----Chapter-module---exiting---BacMu","fadeIn":"src-templates----Chapter-module---fadeIn---1dG4I","fadeInUp":"src-templates----Chapter-module---fadeInUp---2qvW1","fadeInUpCenter":"src-templates----Chapter-module---fadeInUpCenter---1gn-4","fadeInUpSmall":"src-templates----Chapter-module---fadeInUpSmall---19Tdi","textCoverIn":"src-templates----Chapter-module---textCoverIn---2Ylkv","textCoverOut":"src-templates----Chapter-module---textCoverOut---D2BOH"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/Chapter.module.scss
// module id = 869
// module chunks = 164721891013254